import React, { useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";
import Pagination from "../../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
import Modal from "react-modal";

const RiskAssessmentList = (props) => {
  const { addForm, update } = props;

  const [data, setData] = useState("");
  const [riskAssessmentId, setRiskAssessmentId] = useState();
  const [docurl, setDocUrl] = useState(false);

  const viewPdf = (itemId) => {
    //console.log(itemId);
    setDocUrl("https://www.orimi.com/pdf-test.pdf");

    setRiskAssessmentId(itemId);
  };

  const { sendRequest: getRiskAssessment } = useHttp();

  const getData = () => {
    getRiskAssessment(
      {
        url: `/api/riskAssessment/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log(data);
        const sortedData =
          data.riskAssessment &&
          data.riskAssessment.sort(
            (a, b) => b.riskAssessmentId - a.riskAssessmentId
          );

        setData(sortedData);
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  const { sendRequest: deleteRiskAssessment } = useHttp();

  const deleteData = (e, riskAssessmentId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Risk Assessment?",
      onOk() {
        const data = {
          riskAssessmentId: riskAssessmentId,
        };

        deleteRiskAssessment(
          {
            url: "/api/riskAssessment/",
            body: data,
            method: "DELETE",
          },
          (res) => {
            //console.log(res);
            toast.success("Risk Assessment Deleted Successfully");
            getData();
          }
        );
      },
      onCancel() {},
    });
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px", // Adjust the width as needed
      height: "80%",
      minHeight: "450px",
      overflow: "auto",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    // //console.log(data);

    const Id = data && data.riskAssessmentId;

    getRiskAssessment(
      {
        url: `/api/riskAssessment/?orgId=${localStorage.getItem(
          "orgId"
        )}&riskAssessmentId=${Id}`,
      },
      (res) => {
        //console.log(res);
        setSelectedData(res.riskAssessment);
      }
    );

    //  setSelectedData(data);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Risk Assessment</label>
          </div>

          <div className="col-6 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-3 my-3"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Risk Assessment
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Assessment Date</th>
                          <th>Doc No</th>
                          <th>Executive Name</th>
                          <th>Inspector Name</th>
                          <th>Farmer Name</th>
                          <th>Plot Name</th>
                          <th>Crop Name</th>
                          <th>Variety Name</th>

                          <th>Edit</th>
                          <th>Delete</th>
                          <th>View</th>
                          <th>Pdf</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.riskAssessmentDate}</td>
                                <td>{itm.docNo}</td>
                                <td>{itm.riskAssessmentBy}</td>
                                <td>{itm.inspectorName}</td>
                                <td>{itm.farmerName}</td>
                                <td>{itm.plotName}</td>
                                <td>{itm.cropName}</td>
                                <td>{itm.varietyName}</td>
                                <td>
                                  <button
                                    onClick={() => {
                                      props.addForm(true);
                                      props.update(itm);
                                    }}
                                    className="btn"
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={(e) => deleteData(e, itm)}
                                    className="btn"
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => openModal(itm)}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div className="mx-3">
            <div className="">
              <h4 className="card-title">Risk Assessment Details</h4>
              <div className="card-tools text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  onClick={() => setIsModalOpen(false)}
                >
                  <i className="fas fa-times" />
                </button>
                <hr />
              </div>
            </div>

            <div className="row">
              <p className="col-md-6">
                <b> Date:</b> {selectedData.riskAssessmentDate}
              </p>
              <p className="col-md-6">
                <b>Doc No:</b>
                {selectedData.docNo}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                <b>Executive Name: </b>
                {selectedData.riskAssessmentBy}
              </p>
              <p className="col-md-6">
                <b> Framer Name: </b>
                {selectedData.farmerName}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                {" "}
                <b>Plot Name:</b> {selectedData.plotName}
              </p>
              <p className="col-md-6">
                {" "}
                <b>Crop Name: </b>
                {selectedData.cropName}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                <b>Variety Name:</b> {selectedData.varietyName}
              </p>
              <p className="col-md-6">
                <b> Inspector Name:</b> {selectedData.inspectorName}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                <b> Inspector Mobile: </b>
                {selectedData.inspectorMobileNo}
              </p>
              <p className="col-md-6">
                <b> Inspector EmailId:</b> {selectedData.inspectorEmailId}
              </p>
            </div>
          
            <h5 className="card-title">Risk Assessment Details</h5>
            <br />
            <table className="table table-sm table-bordered text-center">
              <thead>
                <tr className="tableheaderrowview">
                  <th>Sr No</th>
                  <th>Risk Head Name</th>
                  <th>Risk Field Name</th>
                  <th>Probability</th>
                  <th>Severity</th>
                  <th> Risk Score</th>
                  <th>Remark</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.riskAssessmentDetail &&
                  selectedData.riskAssessmentDetail.map((itm, i) => {
                    return (
                      <tr key={i} className="cursor-pointer">
                        <td>{i + 1}</td>
                        <td>{itm.riskHeadName}</td>
                        <td>{itm.riskFieldName}</td>
                        <td>
                          {itm.priorityId == 1
                            ? "Improbable"
                            : itm.priorityId == 2
                            ? "Marginal"
                            : itm.priorityId == 3
                            ? "Occasional"
                            : itm.priorityId == 4
                            ? "Probable"
                            : itm.priorityId == 5
                            ? "Frequent"
                            : ""}
                        </td>
                        <td>
                          {itm.severityId == 1
                            ? "Negligible"
                            : itm.severityId == 2
                            ? "Marginal"
                            : itm.severityId == 3
                            ? "Critical"
                            : itm.severityId == 4
                            ? "Frequent"
                            : ""}
                        </td>
                        <td>{itm.totalRisk}</td>

                        <td>{itm.remark}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </Modal>
    </>
  );
};

export default RiskAssessmentList;
